import { render } from "./FridgeEconaviPage.vue?vue&type=template&id=4cb8441c&scoped=true&ts=true"
import script from "./FridgeEconaviPage.vue?vue&type=script&lang=ts"
export * from "./FridgeEconaviPage.vue?vue&type=script&lang=ts"

import "./FridgeEconaviPage.vue?vue&type=style&index=0&id=4cb8441c&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb8441c"]])

export default __exports__